import { render, staticRenderFns } from "./bind-device.vue?vue&type=template&id=b0395556&scoped=true&"
import script from "./bind-device.vue?vue&type=script&lang=js&"
export * from "./bind-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0395556",
  null
  
)

export default component.exports